var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { tgfGraphics } from "../framework/tgfGraphics";
import { tbBase } from "./tbBase";
import { getPIXIObjectFromTbObject } from "./tbGetPIXIObject";
import { tbGraphics } from "./tbGraphics";
import { PIXI } from "./tbPIXI";
import { tbLoaderManager } from "./tbLoaderManager";
import { tbNineSlice } from "./tbNineSlice";
import { tbSpriteAnimation } from "./tbSpriteAnimation";
import { tbTiling } from "./tbTiling";
var tbImage = /** @class */ (function (_super) {
    __extends(tbImage, _super);
    function tbImage(texture, subImageAmount, parent, pivot) {
        var _this = _super.call(this) || this;
        _this.name = "";
        _this.x = 0;
        _this.y = 0;
        _this.subImages = parent ? parent.subImages : [];
        _this.texture = texture ? texture : parent.texture;
        _this.subImageAmount = subImageAmount ? subImageAmount : parent.subImageAmount;
        _this.resources = PIXI["loader"]["resources"];
        _this.cache = PIXI["utils"]["TextureCache"];
        _this.sprite = undefined;
        _this.sprites = [];
        _this.animation = undefined;
        _this.frames = [];
        _this.added = false;
        _this.parent = parent;
        _this.xOrigin = pivot ? pivot.x : 0;
        _this.yOrigin = pivot ? pivot.y : 0;
        _this.rotation = 0;
        _this.width = parent ? parent.width : 0;
        _this.height = parent ? parent.height : 0;
        _this.scaleX = parent ? parent.scaleX : 1;
        _this.scaleY = parent ? parent.scaleY : 1;
        _this.xOrigin = parent ? parent.xOrigin : _this.xOrigin;
        _this.yOrigin = parent ? parent.yOrigin : _this.yOrigin;
        _this.doRendered = false;
        _this.alpha = 1;
        if (parent === undefined) {
            tbLoaderManager.addImage(_this);
        }
        else {
            _this.addSprite();
        }
        return _this;
    }
    Object.defineProperty(tbImage.prototype, "imageName", {
        get: function () { return this.subImages[0]; },
        enumerable: false,
        configurable: true
    });
    tbImage.prototype.addSprite = function () {
        if (this.added) {
            return;
        }
        var texture = this.cache[this.imageName] || this.texture;
        if (!texture) {
            console.log(this.cache);
            throw new Error("Failed to get texture for image '".concat(this.imageName, "'"));
        }
        else if (!this.texture.didLoad) {
            console.log(texture.loadMoment, texture);
            throw new Error("Attempt to use texture '".concat(this.imageName, "' before it was loaded"));
        }
        this._setSprite(new PIXI["Sprite"](texture));
        this.name = this.imageName;
        for (var i = 0; i < this.subImages.length; i++) {
            this._addSubSprite(this.subImages[i]);
        }
        this.added = true;
    };
    tbImage.prototype._addSubSprite = function (name) {
        var sprite = new PIXI["Sprite"](this.cache[name]);
        sprite["pivot"]["x"] = this.xOrigin;
        sprite["pivot"]["y"] = this.yOrigin;
        this.sprites.push(sprite);
    };
    tbImage.prototype.addImage = function (name) {
        this.subImages.push(name);
        if (this.added) {
            // Image already prepared? Add the sprite immediately
            this._addSubSprite(name);
        }
    };
    tbImage.prototype.gotoAndStop = function (frame) {
        var frameSprite = this.sprites[frame];
        var texture = frameSprite.texture;
        this.changeFrame(texture);
    };
    tbImage.prototype.specialAdd = function (xOrigin, yOrigin) {
        if (xOrigin !== undefined) {
            this.xOrigin = xOrigin;
        }
        if (yOrigin !== undefined) {
            this.yOrigin = yOrigin;
        }
        this._setSprite(new PIXI["Sprite"](this.texture));
    };
    /**
     * @param sprite
     * @returns The texture of the sprite by simply returning sprite.texture.
     * There is no point in actually using this function.
     */
    tbImage.prototype.getTexture = function (sprite) {
        if (sprite) {
            var tmpTexture = sprite["texture"];
            return tmpTexture;
        }
    };
    tbImage.prototype.getNineSlice = function (index, left, top, right, bottom) {
        var _index = index ? index : 0;
        if (this.subImages.length > 0) {
            if (this.frames.length === 0) {
                for (var i = 0; i < this.subImages.length; i++) {
                    this.frames.push(PIXI["Texture"]["fromFrame"](this.subImages[i]));
                }
            }
        }
        if (this.frames.length > 0 && this.frames[_index]) {
            var slice = new tbNineSlice(this.frames[_index], left, top, right, bottom);
            return slice;
        }
        else {
            console.error("Failed to get Nine Slice", this.frames, _index);
        }
    };
    tbImage.prototype.getAnimation = function (x, y, loop, onComplete) {
        if (loop === void 0) { loop = true; }
        this.x = x;
        this.y = y;
        if (this.subImages.length > 1) {
            if (this.frames.length === 0) {
                for (var i = 0; i < this.subImages.length; i++) {
                    this.frames.push(PIXI["Texture"]["fromFrame"](this.subImages[i]));
                }
            }
            if (!this.animation) {
                this.animation = new tbSpriteAnimation(this.frames);
                this.animation.setPosition(this.x, this.y);
                this.animation.setLoop(loop);
                this.animation.setOnComplete(function () { return onComplete === null || onComplete === void 0 ? void 0 : onComplete(); });
            }
            return this.animation;
        }
    };
    tbImage.prototype.setPosition = function (x, y) {
        this.x = x;
        this.y = y;
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["position"]["set"](this.x, this.y);
        }
    };
    tbImage.prototype.setDimensions = function (width, height) {
        this.width = width;
        this.height = height;
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["width"] = this.width;
            this.sprite["height"] = this.height;
        }
    };
    tbImage.prototype.setRotation = function (rotation) {
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["rotation"] = rotation;
            this.rotation = rotation;
        }
    };
    tbImage.prototype.setScale = function (x, y) {
        this.scaleX = x;
        this.scaleY = y;
        if (this.sprite) {
            this.sprite.scale.set(this.scaleX, this.scaleY);
        }
    };
    tbImage.prototype.setAlpha = function (alpha) {
        this.alpha = Math.min(Math.max(alpha, 0), 1);
        this.sprite["alpha"] = this.alpha;
    };
    tbImage.prototype.show = function () {
        if (this.sprite) {
            this.sprite["visible"] = true;
        }
    };
    tbImage.prototype.hide = function () {
        if (this.sprite) {
            this.sprite["visible"] = false;
        }
    };
    tbImage.prototype.getFrame = function (at, isNew) {
        if (at === void 0) { at = 0; }
        if (isNew === void 0) { isNew = false; }
        if (isNew && this.subImages.length > 0) {
            var frame = void 0;
            if (this.subImages[at]) {
                frame = new PIXI["Sprite"](this.cache[this.subImages[at]]);
            }
            return frame;
        }
        else if (this.sprites && this.sprites[at]) {
            return this.sprites[at];
        }
        else if (this.sprite && !this.sprite["_destroyed"]) {
            return this.sprite;
        }
    };
    tbImage.prototype.changeFrame = function (texture) {
        if (!texture) {
            throw Error("Failed to change frame due to an invalid texture");
        }
        this.sprite["texture"] = texture;
    };
    tbImage.prototype.clone = function () {
        return new tbImage(undefined, undefined, this);
    };
    tbImage.prototype.addChild = function (child) {
        if (!this.sprite || this.sprite["_destroyed"]) {
            return;
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            if (this.sprite && !this.sprite["_destroyed"]) {
                this.sprite["addChild"](child);
            }
        }
    };
    tbImage.prototype.removeChild = function (child) {
        if (!this.sprite || this.sprite["_destroyed"]) {
            return;
        }
        child = getPIXIObjectFromTbObject(child);
        if (child) {
            if (this.sprite && !this.sprite["_destroyed"]) {
                this.sprite["removeChild"](child);
            }
        }
    };
    /**
     * Add this image to the given container.
     * It will add itself directly to the main canvas if the container is invalid.
     */
    tbImage.prototype.add = function (container) {
        if (!this.sprite || this.sprite["_destroyed"]) {
            return;
        }
        if (container === null || container === void 0 ? void 0 : container["addChild"]) {
            container["addChild"](this.sprite);
        }
        else {
            tgfGraphics.addChild(this.sprite);
        }
    };
    tbImage.prototype.remove = function (container) {
        if (!this.sprite || this.sprite["_destroyed"]) {
            return;
        }
        if (container === null || container === void 0 ? void 0 : container["removeChild"]) {
            container["removeChild"](this.sprite);
        }
        else {
            tgfGraphics.removeChild(this.sprite);
        }
    };
    tbImage.prototype.free = function (alsoChildren) {
        var _a;
        if (alsoChildren === void 0) { alsoChildren = true; }
        var options = {
            "children": alsoChildren,
            "texture": false,
            "baseTexture": false
        };
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["destroy"](options);
            this.sprite = null;
        }
        if (((_a = this.sprites) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            for (var i = 0; i < this.sprites.length; i++) {
                this.sprites[i]["destroy"](options);
            }
            this.sprites = [];
        }
    };
    tbImage.prototype.setTint = function (tint) {
        if (this.sprite) {
            this.sprite["tint"] = tint;
        }
    };
    tbImage.prototype.setBlendmode = function (blendMode) {
        if (this.sprite) {
            this.sprite["blendMode"] = blendMode;
        }
    };
    tbImage.prototype.setMask = function (mask) {
        if (this.sprite) {
            this.sprite["mask"] = mask;
        }
    };
    tbImage.prototype.frameTint = function (tint, index) {
        if (index === void 0) { index = 0; }
        if (this.frames && this.frames[index]) {
            this.frames[index]["tint"] = tint;
        }
    };
    tbImage.prototype.frameMask = function (mask, index) {
        if (index === void 0) { index = 0; }
        if (this.frames && this.frames[index]) {
            this.frames[index]["mask"] = mask;
        }
    };
    tbImage.prototype.getTiling = function (width, height) {
        var tiling = new tbTiling(this.cache[this.imageName], width, height);
        return tiling;
    };
    tbImage.prototype.setBlur = function (value) {
        if (value === void 0) { value = 0; }
        if (this.sprite && !this.sprite["_destroyed"]) {
            var filter = new PIXI["filters"]["BlurFilter"]();
            filter["blur"] = value;
            this.sprite["filters"] = [filter];
        }
    };
    tbImage.prototype.setCallback = function (callback, onDown) {
        if (onDown === void 0) { onDown = false; }
        if (this.sprite && !this.sprite["_destroyed"]) {
            this.sprite["interactive"] = true;
            if (onDown) {
                this.sprite["on"]("pointerdown", callback);
            }
            else {
                this.sprite["on"]("pointerup", callback);
            }
        }
    };
    tbImage.prototype.cancelCallback = function (call) {
        if (this.sprite && !this.sprite["_destroyed"] && call && this.sprite["interactive"]) {
            this.sprite["on"]("pointerupoutside", call);
        }
    };
    tbImage.prototype.complete = function () {
        return this.texture.complete();
    };
    tbImage.prototype.applyCircleMask = function (x, y, radius) {
        x = x !== undefined ? x : this.sprite.width / 2;
        y = y !== undefined ? y : this.sprite.height / 2;
        radius = radius || this.sprite.width / 2;
        var mask = tbGraphics.drawDisk(x, y, radius, 0xffffff, null, 0);
        this.sprite.mask = mask;
        this.sprite.addChild(mask);
    };
    tbImage.prototype.setSize = function (width, height) {
        this.setDimensions(width, height);
    };
    tbImage.prototype.bringToFront = function () {
        if (this.sprite.parent) {
            var parent_1 = this.sprite.parent;
            parent_1.removeChild(this.sprite);
            parent_1.addChild(this.sprite);
        }
    };
    tbImage.prototype.applyColorOverlay = function (color, alpha) {
        if (alpha === void 0) { alpha = 1; }
        var clone = this.clone();
        clone.setTint(color);
        clone.setAlpha(alpha);
        clone.setPosition(this.xOrigin, this.yOrigin);
        this.addChild(clone);
    };
    tbImage.prototype._setSprite = function (sprite) {
        this.sprite = sprite;
        this.width = this.sprite["width"];
        this.height = this.sprite["height"];
        this.sprite["pivot"]["x"] = this.xOrigin;
        this.sprite["pivot"]["y"] = this.yOrigin;
        this.setScale(this.scaleX, this.scaleY);
    };
    return tbImage;
}(tbBase));
export { tbImage };
